<template>
	<section class="asset-classes-section container">
		<div class="text-align-center mb-400">
			<div class="overline mb-100">Asset classes</div>
			<h2 class="heading-1">Explore our offerings</h2>
		</div>
		<div class="display-flex flex-direction-column gap-300 col-10-xl mx-auto">
			<InfoCardsHorizontalMedia :cards="strategies" />
		</div>
	</section>
</template>
<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { InfoCard } from 'types/layout';
import InfoCardsHorizontalMedia from '@components/layout/info-cards-horizontal-media.vue';

const strategies: Array<InfoCard> = [
	{
		title: 'Real estate',
		description: [
			'Fundrise is one of the 50 largest real estate private equity investors in the world by total annual deployment — deploying more than $1 billion of capital annually in 2021 and 2022. Our portfolio is largely composed of 20,000+ well-located residential units and eCommerce-centric industrial assets.'
		],
		link: { text: 'Explore our real estate portfolio', router: 'real-estate-strategies' },
		imageUrl: `${appCloudfrontPath}/images/marketing-site/asset-class-card-real-estate.png`
	},
	{
		title: 'Private credit',
		description: [
			'Skyrocketing interest rates have created broad credit market dislocations and a potential liquidity crisis. The result is arguably the most attractive, risk-adjusted private credit investing opportunity of the last few decades.'
		],
		link: {
			text: `Explore our private credit portfolio`,
			router: 'private-credit'
		},
		imageUrl: `${appCloudfrontPath}/images/marketing-site/asset-class-card-private-credit.png`
	},
	{
		title: 'Venture capital',
		description: [
			'Investing in high-growth private technology companies has proven to be one of the best performing strategies of the last 50 years. VCX, our NYSE-listed public venture fund, targets mid-to-late stage companies in sectors like Modern Data Infrastructure, FinTech, and AI/ML.'
		],
		link: {
			text: 'Learn more about VCX',
			href: 'https://getvcx.com',
			target: '_blank',
			rel: 'noopener noreferrer'
		},
		imageUrl: `${appCloudfrontPath}/images/marketing-site/asset-class-card-vcx.webp`
	}
];
</script>

<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;

.asset-classes-section {
	padding-top: 4rem;
	padding-bottom: 4rem;

	@include respond-to(md) {
		padding-top: 7.5rem;
		padding-bottom: 7.5rem;
	}
}
</style>
